<template>
  <div class="article-cover" :class="customClass">
    <div class="image-box" :class="{'cover-loaded': coverLoaded}">
      <img :src="imgPath" alt="" @load="coverLoaded = true" ref="image" draggable="false" ondragstart="return false;">
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "ArticleCover",
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    image: String
  },
  data() {
    return {
      imgPath: require('../assets/images/' + this.image),
      coverLoaded: false,
      progressOpacity: 1,
      isHeader: false
    }
  },
  computed: {
    customClass() {
      return this.color + (this.isHeader ? ' is-header' : '');
    }
  },
  emits: ['cover-change'],
  watch: {
    progressOpacity() {
      this.$emit('cover-change', {progressOpacity: this.progressOpacity});
    }
  },
  mounted() {
    const t = this;
    const image = this.$refs.image;

    gsap.to(image,{
      opacity: 0,
      //top: '50%',
      scrollTrigger: {
        trigger: image,
        scrub: 0,
        scroller: '.content-wrapper',
        start: 'top 0',
        onUpdate: function (e) {
          const val = Math.round(e.progress * 100) / 100;
          t.progressOpacity = 1 - val * 1.2 > 0 ? 1 - val * 1.2 : 0;
          image.style.transform = 'translate3d(0, ' + Math.round(e.progress * 500) / 10 + '%, 0)';
          t.isHeader = e.progress >= 1;
        }
      }
    });
  }
}
</script>

<style scoped>
  .article-cover {
    position: sticky;
    top: calc(106px - 100vh);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    width: 100%;
    height: 100vh;
    z-index: 1;
    background-color: #C7125C;
  }
  .article-cover.yellow {
    background-color: #FCC500;
  }
  .article-cover.blue {
    background-color: #102D61;
  }
  .article-cover.gradient {
    background: linear-gradient(70deg, #B1D995 0%, #3CB2B8 100%);
  }
  .is-header {
    z-index: 3;
  }
  .image-box {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    opacity: 0;
    transition: 0.5s linear;
    overflow: hidden;
  }
  .image-box.cover-loaded {
    opacity: 1;
  }
  img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media(max-width: 1199px), (max-height: 799px) {
    .article-cover {
      top: calc(78px - 100vh);
    }
  }

  @media(max-width: 999px) {
    .article-cover {
      height: 70vw;
      top: calc(84px - 70vw);
    }
    .image-box {
      height: 70vw;
    }
  }

  @media(max-width: 567px) {
    .article-cover {
      height: 100vw;
      top: calc(64px - 100vw);
    }
    .image-box {
      height: 100vw;
    }
  }
</style>